import React from "react";
import styles from "./style.module.css";

const Button = ({
  text,
  width,
  height,
  backgroundColor,
  onclick,
  color,
  id,
  paddingBottom,
  paddingRight,
  disabled,
  opacity,
  minWidth,
  fontSize,
  boxShadow,
  borderRadius,
  border,
  cursorPointer,
  padding,
  loading,
  margin,
  marginRight,
  marginLeft,
  minHeight,
  style = {},
  ...restProps
}) => {
  return (
    <button
      className={styles.Button}
      style={{
        borderRadius: `${borderRadius}px`,
        width: `${width}`,
        height: `${height}`,
        backgroundColor: `${backgroundColor}`,
        color: `${color}`,
        fontSize: `${fontSize}px`,
        boxShadow: boxShadow,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        minWidth: `${minWidth}vh`,
        opacity: `${opacity}`,
        marginRight: `${marginRight}`,
        marginLeft: `${marginLeft}`,
        border: border,
        padding: padding,
        cursor: cursorPointer,
        margin: margin,
        minHeight: `${minHeight}`,
        ...style,
      }}
      onClick={onclick}
      id={id}
      disabled={disabled}
      {...restProps}
    >
      {loading && (
        <i class="fa fa-spinner fa-spin" style={{ marginRight: 10 }}></i>
      )}
      {text}
    </button>
  );
};
export default Button;
